import tradingPlatformsJson from './content/trading-platforms.json';

export const tradingPlatformsMock = {
    layoutType: 2,
    data: {
        name: 'trading-platforms',
        areasList: [
            {
                id: 1,
                name: 'TradingPlatformsPage',
                componentName: 'Comp:TradingPlatformsPage',
                content: JSON.stringify(tradingPlatformsJson)
            }
        ]
    }
};
